<template>
  <nav
    class="w-full h-full py-1 lg:py-4 2xl:py-8 overflow-x-auto"
    role="navigation"
    aria-label="Main navigation"
  >
    <ul v-for="(group, i) in groups" :key="i" class="flex flex-col py-2 2xl:py-3">
      <span class="subheader pl-3">{{ $t(`mygwf.views.groups.${group.name}`) }}</span>
      <li v-for="link in navigation(group.id)" :key="link.name" @click="emitClose()">
        <BaseLink :name="link.name" class="nav-item nav_space-p">
          <BaseIcon class="icon mr-4 text-lg flex" :icon="link.meta.nav.icon" />
          <span class="truncate">{{ $t(`mygwf.views.${link.name}.title`) }}</span>
        </BaseLink>
      </li>
    </ul>
  </nav>
</template>

<script>
import {userRoutes, groups} from '@/router/routes'
import {BaseIcon, BaseLink} from '@/components/base'

export default {
  computed: {
    navRoutes() {
      return userRoutes.filter(route => route.meta && route.meta.nav)
    },
    groups() {
      return groups.filter(group =>
        this.navRoutes.some(
          route =>
            route.meta.nav.group === group.id &&
            this.$store.getters['auth/isPermitted'](route.meta.rule)
        )
      )
    },
  },
  components: {
    BaseIcon,
    BaseLink,
  },
  methods: {
    navigation(group) {
      return this.navRoutes.filter(
        route =>
          route.meta.nav.group === group && this.$store.getters['auth/isPermitted'](route.meta.rule)
      )
    },
    emitClose() {
      setTimeout(() => {
        this.$emit('close-sidenav')
      }, 0)
    },
  },
}
</script>
<style scoped>
.nav-item {
  @apply text-white select-none no-underline outline-none flex items-center h-full text-base;

  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  opacity: 1;
  -webkit-transition: opacity 0.2s;
  -moz-transition: opacity 0.2s;
  -ms-transition: opacity 0.2s;
  -o-transition: opacity 0.2s;
  transition: opacity 0.2s;
}

@screen 2xl {
  .nav-item {
    @apply py-2;
  }
}

.nav-item:focus-visible {
  outline-width: 5px;
}

.nav-item > .icon {
  @apply opacity-50;

  -webkit-transition: opacity 0.2s;
  -moz-transition: opacity 0.2s;
  -ms-transition: opacity 0.2s;
  -o-transition: opacity 0.2s;
  transition: opacity 0.2s;
}

.nav-item.router-link-active {
  @apply bg-primary-light opacity-100;
}

.nav-item:hover,
.nav-item:hover .icon,
.nav-item.router-link-active .icon {
  @apply opacity-100 text-white;
}

.subheader {
  @apply text-white relative select-none z-10 overflow-hidden opacity-25 h-auto mt-2 mb-1 tracking-wide uppercase font-secondary;

  font-size: 0.725rem;
}

.subheader::after {
  @apply bg-white w-full mx-2 h-px absolute overflow-hidden;

  top: 50%;
  opacity: 0.25;
  z-index: 1;
  content: '';
}
</style>
